import React from "react";

import { PHARUCUT_URL } from "../../../config/produtos";

/**
 * Família Pharu + LGPD. Link só onde existe destino real: o PharuCut tem
 * domínio próprio; o Pharu 3D e uma página de privacidade ainda não.
 */
export default function Rodape({ marca }) {
  return (
    <footer className="e-foot">
      <span>
        família Pharu ·{" "}
        {/* No host do painel "/" é o próprio painel, não o ERP. */}
        {marca.ehPainel ? (
          <span>Pharu ERP</span>
        ) : (
          <a className="me" href="/" aria-current="page">
            Pharu ERP
          </a>
        )}{" "}
        · <a href={PHARUCUT_URL}>PharuCut</a> · <span>Pharu 3D</span>
      </span>
      <span>LGPD · Privacidade</span>
    </footer>
  );
}
